'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $f_Lcom_raquo_airstream_core_Signal__onStart__V($thiz) {
  $thiz.b3();
}
export { $f_Lcom_raquo_airstream_core_Signal__onStart__V as $f_Lcom_raquo_airstream_core_Signal__onStart__V };
function $is_Lcom_raquo_airstream_core_Signal(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.az)));
}
export { $is_Lcom_raquo_airstream_core_Signal as $is_Lcom_raquo_airstream_core_Signal };
function $isArrayOf_Lcom_raquo_airstream_core_Signal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.az)));
}
export { $isArrayOf_Lcom_raquo_airstream_core_Signal as $isArrayOf_Lcom_raquo_airstream_core_Signal };
